import { Route, Routes } from 'react-router-dom';

import TestPage from '../Pages/TestPage';
import RegenPlastic from '../Pages/RegenPlastic';

function Router() {

  return (
    <Routes>
      {/* 광고 페이지 추가 */}
      <Route path='/regen' element={<RegenPlastic/>} />
      <Route path='/test' element={<TestPage/>} />
    </Routes>
  );
}

export default Router;
